import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { NodeViewContent, type ReactNodeViewProps } from '@tiptap/react';

export default function ZyTermNodeView({ decorations }: ReactNodeViewProps) {
    return (
        <ZyNodeViewWrapper
            decorations={decorations}
            as="span"
        >
            <span className="items-center rounded-md border border-purple-200 bg-purple-50 px-2 text-purple-900 hover:bg-purple-100 hover:bg-opacity-100">
                <span
                    contentEditable={false}
                    className="mr-2 rounded-sm bg-purple-600 px-1.5 text-xs text-white"
                >
                    <span>zyTerm</span>
                </span>
                <NodeViewContent<'span'> as="span" />
            </span>
        </ZyNodeViewWrapper>
    );
}
